import { getJSON } from 'js-cookie';

export const getCookieValue = function(name) {
  const value = '; ' + document.cookie,
    parts = value.split('; ' + name + '=');
  return parts.length > 1 ? parts.pop().split(';').shift() : false;
};

const oneYearExpires = () => {
  // generate cookie 'expire' attribute with a value of 1 year (365*24*60*60*1000 ms)
  return (new Date((new Date()).getTime() + (365 * 24 * 60 * 60 * 1000))).toUTCString();
};

export const setLangCookieAndReload = function(lang) {
  if (lang === getCookieValue('huLang')) {
    return;
  }


  document.cookie = 'huLang=' + lang + '; path=/; expires=' + oneYearExpires();

  // Reload the page
  window.location.reload();
};

export const setReferrerPathCookie = () => {
  if (isAnalyticsAccepted() && getCookieValue('huReferrerPath') !== 'BG') {
    document.cookie = 'huReferrerPath=BG; path=/; expires=' + oneYearExpires();
  }
};

export const isAnalyticsAccepted = () => {
  const cookie = getJSON('CookieControl');
  if (typeof cookie === 'object' && cookie.optionalCookies && cookie.optionalCookies.analytics) {
    return cookie.optionalCookies.analytics === 'accepted';
  }
  return false;
};



// WEBPACK FOOTER //
// ./app/assets/js/utils/cookie.js